<template>
  <li>
    <NuxtLink
      v-if="buttonLink"
      external
      :class="`
        flex
        p-0
        flex-col
        h-full
        bg-surface-action-2
        rounded-md
        border-sm
        border-border-tertiary
        shadow-card
        overflow-hidden
        test--subscription-item
        min-h-[42.6rem]
        lg:min-h-[47.4rem]
        pointer
        hover:bg-surface-action-hover
        active:shadow-buttonSoft
        no-underline
        focus-rounded
      `"
      :to="buttonLink"
    >
      <PostPaidCardContent
        :product="props.product"
        :button-text="props.buttonText"
        :card-img="props.cardImg"
        :card-icons="props.cardIcons"
      />
    </NuxtLink>
    <div
      v-else
      role="link"
      tabindex="0"
      :class="`
        flex
        flex-col
        h-full
        bg-surface-action-2
        rounded-md
        border-sm
        border-border-tertiary
        shadow-card
        overflow-hidden
        test--subscription-item
        min-h-[42.6rem]
        lg:min-h-[47.4rem]
        pointer
        hover:bg-surface-action-hover
        active:shadow-buttonSoft
        halebop-focus-rounded
      `"
      :data-testid="
        [
          'abonnemang',
          plan?.IsStudent ? 'Student' : 'notStudent',
          plan?.IsFamilyPlan ? 'Family' : 'notFamily',
          plan?.DataAllowance,
        ].join('_')
      "
      @click="goToCheckout"
      @keyup.enter.self.prevent="goToCheckout"
    >
      <PostPaidCardContent
        :product="props.product"
        :button-text="props.buttonText"
        :card-img="props.cardImg"
        :card-icons="props.cardIcons"
      />
    </div>
  </li>
</template>

<script lang="ts" setup>
import type { ListingProduct } from '~/models/ListingProduct.api.model';
import type { AddBundleToCartRequestModel } from '~/models/shopping_cart/AddBundleToCartRequest.api.model';
const notifications = useNotificationStore();
const { $api } = useNuxtApp();

const props = defineProps<{
  product: ListingProduct;
  buttonLink?: string;
  buttonText?: string;
  cardImg?: string;
  cardIcons?: string[];
}>();

const bundle = props.product?.Variants?.at(0)?.Prices.BundlePrices?.at(0);
const plan = bundle?.Plan;
const { pushAddToCartEvent } = useGoogleAnalyticsEvents();

const goToCheckout = async () => {
  if (bundle?.BundlePriceId) {
    try {
      const requestPayload: AddBundleToCartRequestModel = {
        BundlePriceId: +bundle?.BundlePriceId,
      };
      await $api.ShoppingCartModule.AddBundleToCart(requestPayload);

      const trackingData: ProductPageTrackingData = {
        productPriceId: 0,
        downPayTime: '0',
        ecommerce: {
          items: [
            {
              item_brand: 'Halebop',
              item_category: 'Abonnemang',
              item_id: plan?.PlanId,
              item_name: 'Halebop ' + plan?.PlanName,
              item_variant: bundle?.BindingPeriod.Months + ' månader',
              price: plan?.MonthlyFee,
              quantity: 1,
            },
          ],
        },
      };
      pushAddToCartEvent(trackingData);
      navigateTo('/shop/varukorg', { external: true });
    } catch (e) {
      notifications.setStandardErrorNotification();
    }
  }
};
</script>

<style>
.rounded-bottom {
  clip-path: ellipse(93% 80% at 49% 17%);
}
</style>
